import { Divider } from '@mui/material';
import styled from 'styled-components';
import Typography from '../../atoms/Typography';
export var FeeContainer = styled.div.withConfig({
  displayName: "style__FeeContainer",
  componentId: "sc-1sy4594-0"
})(["display:flex;flex-direction:row;width:100%;"]);
export var FeeName = styled(Typography).withConfig({
  displayName: "style__FeeName",
  componentId: "sc-1sy4594-1"
})(["&&{color:", ";margin-bottom:0.5rem;font-weight:bold;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.secondaryColor[700];
});
export var FeeDetails = styled.div.withConfig({
  displayName: "style__FeeDetails",
  componentId: "sc-1sy4594-2"
})(["flex-basis:70%;display:flex;flex-direction:column;"]);
export var FeeAmount = styled.div.withConfig({
  displayName: "style__FeeAmount",
  componentId: "sc-1sy4594-3"
})(["flex-basis:30%;display:flex;align-items:flex-end;flex-direction:column;p{color:", ";text-transform:uppercase;}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.secondaryColor[700];
});
export var FeeDivider = styled(Divider).withConfig({
  displayName: "style__FeeDivider",
  componentId: "sc-1sy4594-4"
})(["&&{margin-top:2rem;margin-bottom:2rem;width:100%;}"]);